/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_TimeInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_time = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`12 min read`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_time = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阅读约 12 分钟`)
};

/**
* | output |
* | --- |
* | "12 min read" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_TimeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_time = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_TimeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_TimeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_time(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_time(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_time as "gc.search_guides.gridcraft_excel_compatibility.time" }